interface VehicleState {
  vehicule: Record<string, any> | null;
  selectedRentalCompany: Record<string, any> | null;
  selectedEmployee: Record<string, any> | null;
}

type VehicleAction =
  | { type: "NEWLY_CREATED_VEHICULE"; data: Record<string, any> | null }
  | { type: "OWNER_COMPANY"; data: Record<string, any> | null }
  | { type: "NEWLY_SELECTED_EMPLOYEE_STEP_CREATE_VEHICULE"; data: Record<string, any> | null }
  | { type: string; data?: any };

const initialState: VehicleState = {
  vehicule: null,
  selectedRentalCompany: null,
  selectedEmployee: null,
};

const vehicleReducer = (state = initialState, action: VehicleAction): VehicleState => {
  switch (action.type) {
    case "NEWLY_CREATED_VEHICULE":
      return { ...state, vehicule: action.data };
    case "OWNER_COMPANY":
      return { ...state, selectedRentalCompany: action.data };
    case "NEWLY_SELECTED_EMPLOYEE_STEP_CREATE_VEHICULE":
      return { ...state, selectedEmployee: action.data };
    default:
      return state;
  }
};

export default vehicleReducer;
